// @flow

import * as React from 'react';
import Header from '../blocks/header/index';
import Footer from '../blocks/footer/index';
import type { Node, ComponentType } from 'react';
import {useDeviceInfo} from '../hooks';

export const withHeaderAndFooter = <Props>(Wrapped: ComponentType<Props>, withHeaderBorder: boolean = false): (props: Props) => Node => {
    return function withHeaderAndFooter(props: Props): Node {
        const { isMobile } = useDeviceInfo();
        return <>
            <Header isMobile={ isMobile } withHeaderBorder={withHeaderBorder} {...props}/>
            <Wrapped {...props} />
            <Footer isMobile={ isMobile } {...props}/>
        </>;
    };
};

export default withHeaderAndFooter;
